import React from 'react';
import PropTypes from 'prop-types';

import style from './style.scss';

function CarAttributes({ car, colour, year, vrm, mileage }) {
  return (
    <React.Fragment>
      <div className={style.carName}>{car}</div>
      <div className={style.carAttributeContainer}>
        <div className={style.carAttribute}>
          <div className={style.label}>Colour</div>
          <div className={style.value}>{colour}</div>
        </div>
        <div className={style.divider} />
        <div className={style.carAttribute}>
          <div className={style.label}>Year</div>
          <div className={style.value}>{year}</div>
        </div>
        <div className={style.divider} />
        <div className={style.carAttribute}>
          <div className={style.label}>Registration</div>
          <div className={style.value}>{vrm.toUpperCase()}</div>
        </div>
        <div className={style.divider} />
        <div className={style.carAttribute}>
          <div className={style.label}>Mileage</div>
          <div className={style.value}>
            {parseInt(mileage).toLocaleString()}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

CarAttributes.propTypes = {
  car: PropTypes.string,
  colour: PropTypes.string,
  year: PropTypes.string,
  vrm: PropTypes.string,
  mileage: PropTypes.string
};

export default CarAttributes;



// WEBPACK FOOTER //
// ./src/components/CarAttributes/index.js